import React from 'react';
import { BusinessFormPage } from './BusinessForm';

export const CustomerBusinessFormPage: React.FC = () => {
  return <BusinessFormPage isCustomerPortalPage />;
};

